import moment from 'moment';

export const getTenant = () => {
  const details = {
    type: 'main',
    title: 'Hilal (UM)',
  };
  return details;
};

export const toUTC = (time) => moment(time).subtract(8, 'hours');

export const fromUTC = (time) => moment(time).add(8, 'hours');

export const initialsFromUser = user => {
  const str = (user.name || user.email);
  if (!str) return '';
  return str.replace(/[^0-9a-z ]/gi, '').split(' ')
    .map(i => i.charAt(0)).join('')
    .toUpperCase()
    .slice(0, 2);
};

export const a11yProps = (index) => ({
  id: `simple-tab-${index}`,
  'aria-controls': `simple-tabpanel-${index}`,
});

export const stringToColor = str => {
  const hashCode = (s) => {
    let hash = 0;
    for (let i = 0; i < s.length; i++) {
      hash = s.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
  };
  const intToRGB = (i) => {
    const c = (i & 0x00FFFFFF)
      .toString(16)
      .toUpperCase();

    return ''.substring(0, 6 - c.length) + c;
  };

  return `#${intToRGB(hashCode(str))}`;
};

export const snakeCaseToTitleCase = str => {
  if (!str) return str;

  const sentence = str.replace(/_/gi, ' ').toLowerCase().split(' ');
  for (let i = 0; i < sentence.length; i++) {
    sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
  }

  return sentence.join(' ');
};

export const endsWithAny = (suffixes, string) => !!suffixes.find(suffix => string.endsWith(suffix));
